/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";

/*------------------------------------*\
    PRODUCT GALLERY
\*------------------------------------*/
class TruckGallery {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carouselElem = self.elem.querySelector('[data-truck-gallery]');
        self.thumbs = self.elem.querySelectorAll('[data-truck-gallery-thumb]');
        self.carouselItems = self.elem.querySelectorAll('[data-truck-gallery-item]');
    }

    init() {
        let self = this;

        self.initCarousel();
        //self.initMagnify();
    }

    initCarousel() {
        let self = this;

        const flkty = new Flickity(self.carouselElem, {
            pageDots: false,
            //resize: true,
            cellAlign: 'left',
            adaptiveHeight: true,
            prevNextButtons: false
        });


        // Thumbs
        [...self.thumbs].map(thumb => {

            // Get the index of the carousel slide to which this thumb relates
            let index = parseInt(thumb.getAttribute('data-truck-gallery-thumb')) - 1;


            // When the thumb is clicked...
            thumb.addEventListener('click', evt => {
                evt.preventDefault();

                // Select the appropriate slide in the carousel
                flkty.select(index);
            });
        });

        // On change of carousel slide
        flkty.on('select', index => {
            // Update selected thumbnail
            [...self.thumbs].map(thumb => {
                if (thumb.getAttribute('data-truck-gallery-thumb') == (index + 1)) {
                    thumb.classList.add('is-active');
                }
                else {
                    thumb.classList.remove('is-active');
                }
            });
        });
    }

    initMagnify() {
        let self = this;

        [...self.carouselItems].map(item => {
            let magnifiedImage = item.querySelector('[data-truck-gallery-magnified-image]');

            item.addEventListener('mouseover', evt => {
                item.classList.add('is-magnified');
            });

            item.addEventListener('mouseout', evt => {
                item.classList.remove('is-magnified');
            });

            item.addEventListener('mousemove', evt => {
                let rect = item.getBoundingClientRect();

                let x = evt.clientX - rect.left;
                let y = evt.clientY - rect.top;

                magnifiedImage.style.transformOrigin = x + 'px ' + y + 'px';
            });
        });
    }

}

export default TruckGallery;